import { atom } from 'recoil'

import type { ConnectionState } from 'Pages/ImportFattureInCloud/types'

export const importState = atom<ConnectionState>({
  key: 'importFattureInCloud_importState',
  default: {
    loading: false,
  },
})
